'use strict';

import React from 'react';
import { View, SafeAreaView, Platform } from 'react-native';
import PropTypes from 'prop-types';
import CommonStyles from 'common/CommonStyles';

const SafeAreaContainer = (props) => {
  if (props.type === 'custom' && Platform.OS === 'ios') {
    let top = CommonStyles.statusBarHeight;
    let bottom = CommonStyles.pageContainerBottomSpace;
    if (props.overlayStatusBar) {
      top = 0;
    }
    if (props.overlayTouchBar) {
      bottom = 0;
    }
    return (
      <View style={[{ ...props.style }, { marginTop: top, marginBottom: bottom }]} >
        {props.children}
      </View>
    );
  } else if (props.type === 'rnDefault') {
    return (
      <SafeAreaView style={[{ ...props.style }]}>
        {props.children}
      </SafeAreaView>
    );
  } else {
    return (
      <View style={[{ ...props.style }]} >
        {props.children}
      </View>
    );
  }
};

SafeAreaContainer.propTypes = {
  type: PropTypes.oneOf([
    'custom',
    'rnDefault',
  ]),
  overlayStatusBar: PropTypes.bool,
  overlayTouchBar: PropTypes.bool,
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};
SafeAreaContainer.defaultProps = {
  /**
     *容器类型，默认自定义。'rnDefault'为RN自带样式
     */
  type: 'custom',

  /**
     * 状态栏是否沉浸式
     */
  overlayStatusBar: true,

  /**
     * ios 底部touch bar是否透明
     */
  overlayTouchBar: false,

  /**
     * 容器默认样式
     */
  style: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
};

export default SafeAreaContainer;
